// Components
import VerifyEmailView from "../../components/verifyEmail";

const VerifyEmail = () => <VerifyEmailView />;

export default VerifyEmail;
